import { connect } from "react-redux";
import {
  ModalMigration,
  ModalMigrationStateProps,
  ModalMigrationDispatchProps,
} from "senac-components/dist/components/ModalMigration/ModalMigration";
import { userSlice } from "../store/reducers";
import { AppDispatch, RootState } from "../store";
import {
  authenticateFromProfileContext,
  checkUniqueLogin,
  forgotPasswordFromLibrary,
  onCloseMigrationModal,
  sendCPFEmail,
  sendNewLogin,
  signinFromProfile,
  signinMigration,
} from "../store/reducers/userSlice";

const mapState = (state: RootState) => {
  const organizations = (state.userState.organizations ?? []).map((item) => ({
    ...item,
    migrated: (state.userState.projects ?? []).some(
      (project) => project.uid === item.uid
    ),
  }));
  const result: ModalMigrationStateProps = {
    open: state.userState.openModalMigration ?? false,
    organizations,
    step: state.userState.step ?? 0,
    loading: state.userState.userAuthenticating,
    context: state.userState.user ? "profile" : "login",
    preSettedLogin: state.userState.lastCpfSetted,
  };

  return result;
};

const mapDispatch = (dispatch: AppDispatch) => {
  const result: ModalMigrationDispatchProps = {
    sendOrganization: (pass, orgId, login) => {
      dispatch(
        userSlice.actions.sendUserOrganization({
          login: login ?? "",
          password: pass,
          organizationUid: orgId,
        })
      );
    },
    onConfirmSignIn: (params) => {
      dispatch(signinFromProfile(params as any));
    },
    sendCPFOrEmail: (newValue) => {
      dispatch(sendCPFEmail(newValue));
    },
    sendUniqueLogin: (login) => {
      dispatch(sendNewLogin(login));
    },
    onClose: () => {
      dispatch(onCloseMigrationModal());
    },
    setStep: (newStep) => {
      dispatch(userSlice.actions.changeStep(newStep));
    },
    onConfirm: () => {
      dispatch(checkUniqueLogin());
    },
    onClickForgotPassword: (params) => {
      dispatch(forgotPasswordFromLibrary(params));
    },
    sendPasswordToAuthOtherProfile(password) {
      dispatch(authenticateFromProfileContext(password))
    },
  };

  return result;
};

export const WModalMigration = connect(mapState, mapDispatch)(ModalMigration);
